exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-tourists-mask{position:fixed;top:0;left:0;bottom:0;right:0;z-index:10;background-color:#fafafa;display:flex;align-items:center;justify-content:center}", ""]);

// exports
